import URLUtils from '../URLUtils';

export const getImgWidth = (url: string): string => {
  const { width = '' } = URLUtils.getQueryMap(url);
  return width ? `${(Number(width) / 375) * 100}vw` : '0';
};
